import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SwitchCompanyLoaderReducer } from '../reducers';

export const switchCompanyLoaderFeature = createFeatureSelector<SwitchCompanyLoaderReducer.DataState>(SwitchCompanyLoaderReducer.featureName);

export const selectFeatureAppointmentType = createSelector(switchCompanyLoaderFeature, (state: SwitchCompanyLoaderReducer.DataState) => state.companySelected);
